import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, InputNumber, Button, Tabs, notification, Switch } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import './BookingSubCategoryModal.css';

const { Text } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'BookingSubCategoryStore',
)
@observer
class BookingSubCategoryModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
    }

    // ON CHANGE

    nameOnChange = (langId, e) => {
        this.props.BookingSubCategoryStore.setBookingSubCategoryLanguageName(langId, e.target.value);
    }

    capacityOnChange = (value) => {
        this.props.BookingSubCategoryStore.setCapacity(value);
    }

    isAvailableOnChange = (value) => {
        this.props.BookingSubCategoryStore.setIsAvailable(value);
    }

    maxHourPerDayOnChange = (value) => {
        this.props.BookingSubCategoryStore.setMaxHourPerDay(value);
    }

    sortOrderOnChange = (value) => {
        this.props.BookingSubCategoryStore.setSortOrder(value);
    }

    // ON Search

    bookingCategoryOnSearch = () => {
        this.props.BookingSubCategoryStore.setBookingCategorySearchValue('');
        this.props.BookingSubCategoryStore.searchBookingCategory();
        this.props.BookingSubCategoryStore.setShowBookingCategorySearchModal(true);
    }

    // ON CLICK

    createOrUpdateBookingSubCategoryDetailOnClick = () => {
        this.props.BookingSubCategoryStore.createOrUpdateBookingSubCategoryDetail();
    }

    initUpdateBookingSubCategoryDetailOnClick = (bookingSubCategoryDetailId) => {
        this.props.BookingSubCategoryStore.initUpdateBookingSubCategoryDetail(bookingSubCategoryDetailId);
    }

    cancelBookingSubCategoryDetailOnClick = () => {
        this.props.BookingSubCategoryStore.cancelBookingSubCategoryDetail();
    }

    deleteBookingSubCategoryDetailOnClick = (bookingSubCategoryDetailId) => {
        this.props.BookingSubCategoryStore.deleteBookingSubCategoryDetail(bookingSubCategoryDetailId);
    }

    createOrUpdateBookingSubCategoryOnClick = () => {
        const { t } = this.props;
        const { id } = this.props.BookingSubCategoryStore;
        if (id === 0) {
            this.props.BookingSubCategoryStore.createBookingSubCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Sub Category has been successfully created.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingSubCategoryStore.updateBookingSubCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Sub Category has been successfully updated.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabNameOnTabClick = (key) => {
        this.props.BookingSubCategoryStore.setTabNameActiveKey(key);
    }



    render() {
        const { t } = this.props;
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            bookingCategoryName,
            tabNameActiveKey,
            bookingSubCategoryLanguages,
            capacity,
            isAvailable,
            maxHourPerDay,
            sortOrder,
            itemTextButton,
            bookingSubCategoryModalLoading
        } = this.props.BookingSubCategoryStore;

        let addOrUpdateItemDisable = false;
        const primaryLang = bookingSubCategoryLanguages.find(lang => lang.langId === 1);
        if (bookingCategoryName === '' || !primaryLang || primaryLang.name === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={bookingSubCategoryModalLoading}>
                                <Row className='bookingsubcategorymodal-row-container'>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Category')}<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Search
                                                    placeholder={t('Search Category')}
                                                    value={bookingCategoryName}
                                                    onSearch={this.bookingCategoryOnSearch}
                                                    enterButton
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label-tabs'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Sub Category Name')}<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Tabs activeKey={tabNameActiveKey} onTabClick={this.tabNameOnTabClick}>
                                                    {
                                                        activeLanguages && activeLanguages.map(lang => {
                                                            const langData = bookingSubCategoryLanguages.find(bscl => bscl.langId === lang.id);
                                                            const isPrimary = lang.id === 1; // English is primary
                                                            return (
                                                                <TabPane
                                                                    tab={`${lang.originalName}${isPrimary ? ' *' : ''}`}
                                                                    key={lang.id.toString()}
                                                                >
                                                                    <Input
                                                                        className='bookingsubcategorymodal-input'
                                                                        value={langData ? langData.name : ''}
                                                                        onChange={(e) => this.nameOnChange(lang.id, e)}
                                                                    />
                                                                </TabPane>
                                                            );
                                                        })
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Capacity')}<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={1}
                                                    value={capacity}
                                                    onChange={this.capacityOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Max Hour Per Day')}<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={maxHourPerDay}
                                                    onChange={this.maxHourPerDayOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Sort Order')}<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={sortOrder}
                                                    onChange={this.sortOrderOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>{t('Is Available')}</Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Switch checkedChildren={t('Yes')} unCheckedChildren={t('No')} checked={isAvailable} onChange={this.isAvailableOnChange} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingsubcategorymodal-button' onClick={this.createOrUpdateBookingSubCategoryOnClick}>{t(itemTextButton)}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingSubCategoryModalPage);
